<template>

    <v-scroll-x-transition>
        <DragWrapper :top="100" :right="width + 50">

            <v-card v-show="featureProperties" flat :width="width" class="mx-auto">

                    <v-system-bar drag-handle color="primary" dark :window="true">
                            <v-icon color="secondary">mdi-information</v-icon>
                            <span>Properties</span>
                    </v-system-bar>

                    <v-lazy>
                        <v-tabs color="primary" grow v-model="tab" centered icons>

                            <v-tabs-slider color="secondary"></v-tabs-slider>

                            <v-tab>
                                <v-icon>mdi-format-list-bulleted</v-icon>
                            </v-tab>

                            <v-tab>
                                <v-icon>mdi-chart-line</v-icon>
                            </v-tab>

                            <v-tabs-items v-model="tab">
                                
                                <v-divider color="black"></v-divider>

                                <v-tab-item>

                                    <v-scroll-x-transition hide-on-leave>
                                        <v-card-text v-if="featureProperties != null">
                                            <JsonDisplayList :jsonData="featureProperties" :exclude="['stats', 'geometry']"></JsonDisplayList>
                                        </v-card-text>
                                    </v-scroll-x-transition>

                                </v-tab-item>

                                <v-tab-item>

                                    <v-card-text v-if="featuresLoading">
                                        <v-row justify="center">
                                            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                                        </v-row>
                                    </v-card-text>

                                    <v-scroll-x-transition hide-on-leave>
                                        <v-card-text v-if="featureProperties != null && !featuresLoading">
                                            <JsonDisplayList :jsonData="featureProperties.stats"></JsonDisplayList>
                                        </v-card-text>
                                    </v-scroll-x-transition>

                                </v-tab-item>

                            </v-tabs-items>

                        </v-tabs>
                    </v-lazy>

            </v-card>

        </DragWrapper>
    </v-scroll-x-transition>

</template>

<script>

import DragWrapper from './common/DragWrapper.vue'
import JsonDisplayList from './common/JsonDisplayList.vue'

export default {
    
    components: {
        DragWrapper,
        JsonDisplayList,
    },

    props: {
        width: {
            type: Number,
            default: 300,
        },

        featureProperties: {
            type: Object,
            default : null,
        },

        featuresLoading: {
            type: Boolean,
            default : true
        } 
       
    },

    data: () => ({
        tab : 0,
    }),


};
</script>
